import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    avatarTalk({ getters, commit }, speechText) {
      commit("setIsThinking", false);
      commit("setTextBubbleText", speechText);
      window.sayText(
        speechText,
        getters.getAvatarLangCodes.voiceId,
        getters.getAvatarLangCodes.langId,
        getters.getAvatarLangCodes.engineId
      );
    },

    customRequestQnA({ getters, dispatch, commit }, transcript) {
      // Request to QNA

      const axios = require("axios");
      let lang;
      if (getters.getCurrentLanguage === "en") {
        lang = "english";
      } else if (getters.getCurrentLanguage === "es-US") {
        lang = "spanish";
      } else {
        lang = "english"; //default to englisg if no language is selected in
      }

      let data = JSON.stringify({
        question: transcript,
        lang: lang,
        client: "wm",
        // type: "inside",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      return axios
        .request(config)
        .then((response) => {
          console.log(response.status, "API CALL STATUS");
          return response.data.answer; // ✅ resolves to the answer object
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error, "error is raised here");
        });
    },

    requestQnA({ getters, dispatch, commit }, transcript) {
      // Request to QNA
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }

      const axios = require("axios");

      let lang;
      // console.log(config, "Configguiration");
      commit("setIsThinking", true);
      if (getters.getCurrentLanguage === "en") {
        commit("setTextBubbleText", "Thinking....");
        lang = "english";
      } else if (getters.getCurrentLanguage === "es-US") {
        commit("setTextBubbleText", "Pensando....");
        lang = "spanish";
      } else {
        commit("setTextBubbleText", "Thinking....");
        lang = "english"; //default to englisg if no language is selected in
      }

      let data = JSON.stringify({
        question: transcript,
        lang: lang,
        client: "wm",
        // type: "inside",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.status, "API CALL STATUS");
          // console.log(response.data, "response recived from qna",response.data.answer.intent,response.data.answer.metadata);
          const date = new Date();
          dispatch("addSessionDataToStrapi", {
            applicationId: getters.getKioskProfile.data().applicationId,
            actionType: "QnA",
            applicationSessionId: getters.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "QnA",
              action: transcript,
              response: response.data,
              timeStamp: date.toISOString(),
            },
          });

          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: transcript,
                answer: response.data.answer.response,
                response: response.data,
              },
            },
          });

          console.log("Dispatched generate answer");
          dispatch("generateAnswer", response.data.answer);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error, "error is raised here");
        });
    },
    async generateAnswer({ dispatch, commit, getters }, result) {
      if (getters.getIsThinking) {
        console.log("result:", result);
        commit("setQnaStatus", false);

        const intent = result.intent;
        // const intent = "followup"

        console.log("Intent recieved :", intent);
        const ansObj = result;

        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (intent) {
          case "showprofmap":
            try {
              const mappathIn = result.metadata.mappath || result.metadata.mapname;
              const customAns = result.response;
              console.log(mappathIn, "This is professor room number");
              if (mappathIn) {
                // const customResp =this.customRequestQnA(`Where is ${mappathIn}`)
                const apiData = await dispatch(
                  "customRequestQnA",
                  `Where is ${mappathIn}`
                );
                
                const finalPayload = { 
              ...apiData, 
              response: `${customAns}.${apiData.response}` 
            };
            console.log(finalPayload,"This is finalPayload");
                dispatch("generateAnswer", finalPayload);
              } else {
                dispatch("avatarTalk", ansObj.response);
              }
            } catch (err) {
              console.log("Excpetion in showprofmap");
              console.log(err);
            }
            break;
          case "searchbylinkid":
            try {
              let ans = getters.getMappedFaqByLinkId(result.metadata.linkid);
              console.log(ans, "Required Answer");
              commit("setQnaKeyword", "");
              router.addRoute({
                path: "/faqs",
                component: () => import("@/views/faqs"),
              });
              if (router.currentRoute.path !== "/faqs") {
                router.push("/faqs");
              }
              var page = i18n
                .t("homepages")
                .filter((page) => page.pageType[0].pathName === "faqs");
              commit("setPageHeader", page[0].pageType[0].pageHeader);

              commit("setQnaKeyword", ans.linkId.toString());
              dispatch(
                "avatarTalk",
                "Please read the requested information below."
              );
            } catch (err) {
              console.log("Excpetion in SEARCH BY LINK ID.FIND WHATS WRONG.");
              console.log(err);
            }
            break;
          case "fallback":
          case "speak":
            dispatch("avatarTalk", result.response);
            break;

          case "showmap":
            try {
              console.log(
                "At showmap checking premise: ",
                getters.getKioskProfile.data().kioskPremise
              );

              if (
                getters.getKioskProfile.data().kioskPremise.toLowerCase() ===
                "outside"
              ) {
                const tmpMsg =
                  "Sorry I am still learning. Please see someone at the Counter";
                commit("setIsThinking", false);
                commit("setTextBubbleText", tmpMsg);
                dispatch("avatarTalk", tmpMsg);
              }
              // var mapPath = i18n.t('maps').filter(map => console.log(map,ansObj.metadata.mapposition,"this is what i need"))
              console.log(typeof result.metadata.mappath, "maps needed");

              var mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.displayPosition.toString() === result.metadata.mappath
                );

              if (mapPath) {
                dispatch("openImageViewer", {
                  name: mapPath[0].mapName,
                  url: mapPath[0].mapImage,
                });

                dispatch("avatarTalk", ansObj.response);
              }
            } catch (e) {
              dispatch("avatarTalk", i18n.t("mapNotFound"));
            }
            break;
          case "navigate":
            var menuName = ansObj.metadata.navigateto;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarTalk", ansObj.answer);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarTalk", ansObj.answer);
            }
            break;

          case "showform":
            try {
              console.log("Comming inside showform", ansObj);
              var formName = ansObj.metadata.formname;
              console.log(formName, "this is formName");
              i18n.t("forms").forEach((form) => {
                // console.log(form,formName,"this are formnames");
                if (form.formName.toLowerCase() === formName) {
                  console.log(form, "this are details");
                  dispatch("openPdfViewer", {
                    url: form.document,
                    name: form.formName,
                    desc: "Hello There",
                    emailLink: form.documentUrl,
                    type: form.documentType,
                  });
                  dispatch("avatarTalk", ansObj.answer);
                }
              });
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase()
              );
              dispatch("openImageViewer", {
                name: mapPath.mapName,
                url: mapPath.mapImage,
                floor: i18n.t("defaultfloor"),
                // floor: getters.getDefaultLocationFloor,
              });
              dispatch("avatarTalk", i18n.t("formNotFound"));
            }

            break;
          case "searchbykeyword":
            var redirectedFlag = false;
            i18n.t("faqsWithUrl").forEach((faq) => {
              if (faq.linkId.toString() === ansObj.metadata.linkid) {
                var date = new Date();
                if (faq.urlDetails && faq.urlDetails.urllist[0].redirect) {
                  redirectedFlag = true;

                  //false
                  // dispatch("addSessionDataToStrapi", {
                  //   applicationId: getters.getKioskProfile.data().applicationId,
                  //   actionType: "Session Ended",
                  //   applicationSessionId: getters.getSessionId,
                  //   timeStamp: date.toISOString(),
                  //   sessionPayload: {},
                  // });

                  // dispatch('avatarSpeak', 'Redirecting to Website')
                  // this.$store.commit("setIsThinking", false)
                  // this.$store.commit("setSpeechRecognitionHandler", false);

                  // console.log(page,"This is page alias");
                  console.log(
                    ansObj.metadata.showpopup,
                    "if this value is true show popUp."
                  );
                  if (ansObj.metadata.showpopup) {
                    const message = i18n.t("paymentPopupMsg");
                    commit("setPaymentPopUp", true);
                    commit("setIsThinking", false);
                    commit("setTextBubbleText", message);
                    dispatch("avatarTalk", message);
                  } else {
                    console.log("Redirecting to WM website:", faq);
                    // dispatch("kioskRedirected");
                    // commit("setIsSpeaking", false)
                    commit("setIsThinking", false);
                    commit(
                      "setTextBubbleText",
                      i18n.t("bubbletextafteraction")
                    );

                    // window.location.href = faq.urlDetails.urllist[0].link;
                    window.open(faq.urlDetails.urllist[0].link, "_blank");

                    // this.$store.commit("setDefaultBubbleText", true);
                    // this.$store.commit(
                    //   "setTextBubbleText",
                    //   "Please face towards the camera, tap on the microphone button, and ask a court-related question."
                    // );
                  }
                }
              }
            });

            if (!redirectedFlag) {
              commit("setQnaKeyword", "");
              router.addRoute({
                path: "/faqs",
                component: () => import("@/views/faqs"),
              });
              if (router.currentRoute.path !== "/faqs") {
                router.push("/faqs");
              }
              var page1 = i18n
                .t("homepages")
                .filter((page) => page.pageType[0].pathName === "faqs");
              commit("setPageHeader", page[0].pageType[0].pageHeader);
              var linkId = ansObj.metadata.linkid;
              commit("setQnaKeyword", linkId);
              dispatch("avatarTalk", ansObj.answer);
            }

            break;

          case "showfaqcategory":
            // commit("setQnaKeyword", "")
            // var faqKeyword = ansObj.metadata.keyword

            // router.addRoute({ path: '/faqs', component: () => import('@/views/faqs') })
            // if (router.currentRoute.path !== '/faqs') {
            //     router.push('/faqs')
            // }
            // var page = i18n.t('homepages').filter(page => page.pageType[0].pathName === 'faqs')
            // commit('setPageHeader', page[0].pageType[0].pageHeader)
            // var count = i18n.t('faqCategory').filter(cat => cat.categoryName.toLowerCase() === faqKeyword)
            // if (count.length === 0) {
            //     var englishFaqList = getters.getFaqs.filter(faq => faq.locale === 'en')
            //     var linkId = englishFaqList.filter(faq => faq.question.toLowerCase().includes(faqKeyword))
            //     if (linkId.length > 0) {
            //         commit("setQnaKeyword", linkId[0].linkId)
            //     } else {
            //         mapPath = getters.getMaps.get(getters.getDefaultLocation.toLowerCase())
            //         dispatch('openImageViewer', {
            //             name: mapPath.mapName,
            //             url: mapPath.mapImage
            //         })
            //         dispatch('avatarSpeak', i18n.t('kbError'))
            //     }

            // } else {

            //     commit('setSelectedFaqCat', { name: faqKeyword, type: 'expansionPanel' })
            // }
            // dispatch('avatarSpeak', ansObj.answer);
            break;

          case "showformcategory":
            var formKeyword = ansObj.metadata.keyword;
            router.addRoute({
              path: "/forms",
              component: () => import("@/views/forms"),
            });
            if (router.currentRoute.path !== "/forms") {
              router.push("/forms");
            }
            commit("setPageHeader", "Forms");
            commit("setQnaKeyword", formKeyword);
            dispatch("avatarTalk", ansObj.answer);
            break;

          case "showformpackets":
            var packetInfo = getters.getFormPacketsEnglish.get(
              ansObj.metadata.find(({ name }) => name === "keyword").value
            );
            dispatch("openPdfViewer", {
              url: packetInfo.packetFiles,
              name: packetInfo.packetName,
              desc: packetInfo.packetDesc,
              emailLink: packetInfo.packetLink,
              type: "Packet",
            });
            //dispatch('avatarSpeak', ansObj.answer);
            break;

          case "showhours":
            dispatch("openCourtTimingViewer", {});
            dispatch("avatarTalk", ansObj.answer);

            break;

          case "session":
            var action = ansObj.metadata.find(
              ({ name }) => name === "action"
            ).value;
            if (action === "still there") {
              dispatch("kioskStillThere");
            } else {
              dispatch("resetKiosk");
            }
            break;

          case "followup":
            var followUp = [];
            if (ansObj.metadata.followup && ansObj.metadata.followup.length > 0) {
              console.log("Coming in if block");
              ansObj.metadata.followup.forEach((item) =>
                followUp.push(`Where is Professor ${item}`)
              );
              // commit("setIsThinking", false);
              
              dispatch("openOptionsViewer", {
                dialogHeader: i18n.t("selectOptionMsg"),
                dialogData: followUp,
              });
              dispatch("avatarTalk", ansObj.response);
            }
            else if(ansObj.metadata.followup && ansObj.metadata.followup.length === 0){
              console.log("coming in else if block");
              // commit("setIsThinking", false);
              dispatch("avatarTalk", i18n.t("noAnswer"));
            break;
            } 
            else {
              console.log("coming in else block");
              // commit("setIsThinking", false);
              dispatch("avatarTalk", ansObj.response);

              // prompts.forEach((item) => followUp.push(item.displayText));
              i18n
                .t("followupQuestions")
                .split(",")
                .forEach((item) => followUp.push(item));
              dispatch("openOptionsViewer", {
                dialogHeader: i18n.t("selectOptionMsg"),
                dialogData: followUp,
              });
            }
            break;

          default:
            dispatch("avatarTalk", i18n.t("noAnswer"));
            break;
        }
        console.log("Its not here once switch is ended");
      }
    },
  },
};
